import { api } from "@/lib/api/apiClient";

// Definición de tipos basada en el esquema de Python
export interface User {
  ownerID: string;
  userName: string;
  name: string;
  correo: string;
  region?: string;
  puesto?: string;
  userEstatus?: string;
  tipoUsuario?: string;
  acl: string;
  scope: string;
  forbidden: string[];
  feedback?: string;
  /** Foto de perfil en base64 (data URI) */
  foto?: string;
  /** Solo para formulario de creación/edición; no se persiste en respuestas API */
  password?: string;
}

// api.* ya incluye credentials: "include" para enviar cookies automáticamente
export const userService = {
  getUsers: () => api.get<User[]>("/users/"),

  getUser: (id: string) => api.get<User>(`/users/${id}`),

  getUsersByAcl: (acl: string) => api.get<User[]>(`/users/acl/${acl}`),

  getUsersByPuesto: (puesto: string) => api.get<User[]>(`/users/puesto/${puesto}`),

  getUserByName: (name: string) => api.get<User>(`/users/name/${name}`),

  createUser: (user: any) => api.post<User>("/users/", user),

  updateUser: (id: string, user: any) => api.put<User>(`/users/${id}`, user),

  deleteUser: (id: string) => api.delete<{ message: string }>(`/users/${id}`),

  // Helper to filter users similar to legacy cleanExcept
  filterUsers: (users: User[], _exceptionArray: string[]) => {
      // Client side filtering if needed, or backend handles it
      return users;
  }
};
